import '../sass/bundle.scss';
import Mead from './index';

declare const Vue: any;

/**
 * Entry point for the standalone <script> bundle. When Vue is available as a
 * global (i.e. loaded via its own <script> tag before this one), Mead installs
 * itself as a Vue plugin, registering every mead-* component/filter/directive.
 * Otherwise it just exposes the Mead/MeadCommon globals for non-Vue usage.
 */
(function () {
    if (typeof window === 'undefined') return;

    if (typeof Vue !== 'undefined') {
        Mead.install(Vue);
    } else {
        Mead.mountGlobals();
    }
})();
